import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';


import * as serviceWorker from './serviceWorker';
import Router from './routing/router';
import ErrorBoundary from './scripts/components/errors/error-boundary';
import store from './redux/store/index';

import './styles/main.scss';

import intlEN from 'react-intl/locale-data/en';
import intlES from 'react-intl/locale-data/es';

const container = document.getElementById('root');
const root = createRoot(container);
addLocaleData([...intlEN, ...intlES]);

root.render(
  <IntlProvider
    defaultLocale='es'
    locale='es'
    messages={ {} }>
    <Provider store={ store }>
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    </Provider>
  </IntlProvider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
